<template><section><h2>固定位置</h2>
<p>使用 <code v-pre>Tooltip.position</code> 可以固定 <code v-pre>tooltip</code> 的位置。</p>
<block-demo tip="" source="const data = [
  { value: 1350, label: &#39;直接访问&#39; },
  { value: 2548, label: &#39;搜索引擎&#39; },
  { value: 3340, label: &#39;联盟广告&#39; },
  { value: 350, label: &#39;视频广告&#39; },
  { value: 2100, label: &#39;邮件营销&#39; }
]

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
})

chart.source(data, { row: &#39;label&#39;, value: &#39;value&#39; })

const pie = new Pie()

const tooltip = new Tooltip({ title: &#39;网站流量来源&#39;, pos: [&#39;0%&#39;, 20] })
tooltip.style(&#39;background&#39;, () =&gt; ({ bgcolor: &#39;rgba(0, 0, 0, .5)&#39; }))
tooltip.style(&#39;title&#39;, () =&gt; ({ color: &#39;red&#39; }))
tooltip.style(&#39;icon&#39;, () =&gt; ({ bgcolor: &#39;red&#39; }))
tooltip.style(&#39;text&#39;, () =&gt; ({ color: &#39;blue&#39; }))

chart.append(pie).add(tooltip)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1350</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'直接访问'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2548</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'搜索引擎'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3340</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'联盟广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">350</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'视频广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2100</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'邮件营销'</span> }
]

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
})

chart.source(data, { <span class="hljs-attr">row</span>: <span class="hljs-string">'label'</span>, <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span> })

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie()

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip({ <span class="hljs-attr">title</span>: <span class="hljs-string">'网站流量来源'</span>, <span class="hljs-attr">pos</span>: [<span class="hljs-string">'0%'</span>, <span class="hljs-number">20</span>] })
tooltip.style(<span class="hljs-string">'background'</span>, () =&gt; ({ <span class="hljs-attr">bgcolor</span>: <span class="hljs-string">'rgba(0, 0, 0, .5)'</span> }))
tooltip.style(<span class="hljs-string">'title'</span>, () =&gt; ({ <span class="hljs-attr">color</span>: <span class="hljs-string">'red'</span> }))
tooltip.style(<span class="hljs-string">'icon'</span>, () =&gt; ({ <span class="hljs-attr">bgcolor</span>: <span class="hljs-string">'red'</span> }))
tooltip.style(<span class="hljs-string">'text'</span>, () =&gt; ({ <span class="hljs-attr">color</span>: <span class="hljs-string">'blue'</span> }))

chart.append(pie).add(tooltip)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>